import { render, staticRenderFns } from "./PatientFollowUpList.vue?vue&type=template&id=1f026c6c&scoped=true&"
import script from "./PatientFollowUpList.vue?vue&type=script&lang=js&"
export * from "./PatientFollowUpList.vue?vue&type=script&lang=js&"
import style0 from "./PatientFollowUpList.vue?vue&type=style&index=0&id=1f026c6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f026c6c",
  null
  
)

export default component.exports